module.exports = __webpack_public_path__ + "static/media/linkeding.891c1f83.svg";